export abstract class TimeParser<T> {
  abstract parse(value: string): T | null;
}
